var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect-item',{attrs:{"id":"avlChip","custom-label":_vm.label,"options":_vm.avlChipOptions,"placeholder":"Seleccione Avl Chip","track-by":"id_avl","loading":_vm.isLoading},model:{value:(_vm.avlChip),callback:function ($$v) {_vm.avlChip=$$v},expression:"avlChip"}})
}
var staticRenderFns = []

export { render, staticRenderFns }